import React from "react";
import { cn } from "./cn";

/**
 * Bun internal note: the advisor-only aside inside a client-facing thread.
 * Spec: Component Library "Client message + internal note" — dashed
 * parchment boundary so it can never be mistaken for a sent message.
 *
 *   <InternalNote>not visible to client. RSU window opens Sep 15.</InternalNote>
 */
export default function InternalNote({ label = "Internal", className, children }) {
  return (
    <div
      className={cn(
        "border border-dashed border-bun-note-line bg-bun-note-bg rounded-bun px-3 py-2",
        "font-instrument text-bun-meta font-book text-bun-note-text",
        className
      )}
    >
      <span className="font-semibold">{label} ·</span> {children}
    </div>
  );
}
